import { BaseController } from '../../common/base/controller';

export class ChangelogController extends BaseController {
  // Update according to the changelog files
  changelogFiles = ['changelog-2025-03-13.md', 'changelog-2025-03-12.md'];
  changelogs = [];
  errorMessage = '';

  constructor(controllerService, $http, $q) {
    'ngInject';
    super({
      controllerService,
      $http,
      $q,
    });
  }

  $onInit() {
    this.loadChangelogs();
  }

  loadChangelogs() {
    const changelogs = this.changelogFiles.map((log) =>
      this.loadChangelog(log),
    );
    this.$q
      .all(changelogs)
      .then((changelogs) => {
        this.changelogs = changelogs;
      })
      .catch((error) => this.handleError(error));
  }

  loadChangelog(file) {
    return this.$http
      .get(`assets/changelog/${file}`)
      .then((response) => response.data)
      .catch((error) => error);
  }

  handleError(error) {
    this.error(error);
    this.errorMessage = error;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/changelog/changelog.controller.js